module.exports = __webpack_public_path__ + "img/acqua-palace_44.3419fc76.jpeg";